import { HemisphereLight, OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer } from "three";
function initThree({ canvas, orthographic, bgColor = 16777215, addLights, size }) {
	if (!size) if (canvas instanceof OffscreenCanvas) size = [canvas.width, canvas.height];
	else size = [canvas.clientWidth, canvas.clientHeight];
	const renderer = new WebGLRenderer({
		antialias: true,
		canvas
	});
	renderer.setSize(size[0], size[1], false);
	renderer.setClearColor(bgColor);
	let camera;
	if (orthographic) camera = new OrthographicCamera(-size[0] * .5, size[0] * .5, size[1] * .5, -size[1] * .5, .1, 1e3);
	else camera = new PerspectiveCamera(70, size[0] / size[1], .1, 1e3);
	const scene = new Scene();
	if (addLights) {
		const light1 = new HemisphereLight(16777215, 136);
		light1.position.set(-1, 1.5, 1);
		scene.add(light1);
		const light2 = new HemisphereLight(16777215, 8912896, .5);
		light2.position.set(-1, -1.5, -1);
		scene.add(light2);
	}
	return {
		renderer,
		camera,
		scene
	};
}
export { initThree };

//# sourceMappingURL=index233.js.map